/*
 * Jira Ticket:
 * Created Date: Wed, 18th Mar 2020, 11:56:29 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import create from './create';
import edit from './edit';
import list from './list';
export default {
  create,
  edit,
  list,
};
